export default __webpack_public_path__ + "static/media/03_anis-page.f31e3727.png";